import React from "react";
import { useNavigate } from "react-router-dom";
import { HeroSection } from "./HeroSection";
import { FeaturesSection } from "./FeaturesSection";
import { WhyTeachSection } from "./WhyTeachSection";
import { getCurrentUser, isAuthenticated } from "../../../utils/api";

export const Home = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (isAuthenticated() && getCurrentUser()?.role === "tutor") {
      navigate("/create-profile");
      return;
    }
    navigate("/signup");
  };
  
  const ctaData = {
    title: "Ready to Start Tutoring?",
    subtitle: "Join our community of expert tutors and make a difference today",
    buttonText: "Get Started",
  
  };

  return (
    <div className="w-full bg-white">
      <HeroSection />
      
      <section id="why-teach-on-tutor-scene" className="w-full text-center scroll-mt-24 mt-20">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl text-[#2d3660] font-semibold mb-4">
            Why Tutor on Tutor Scene?
          </h2>
          <p className="text-[#62698b] text-2xl">
            Join and Make A Difference
          </p>
        </div>
      </section>

      <FeaturesSection />
      <WhyTeachSection />

      {/* CTA Section */}
      <section className="w-full bg-gradient-to-b from-[#3495da]/80 to-[#3495da] text-white py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4">{ctaData.title}</h2>
          <p className="text-xl mb-8">{ctaData.subtitle}</p>
          <button
            type="button"
            onClick={handleGetStarted}
            className="px-8 py-3 bg-white text-[#3495da] font-semibold text-lg rounded-lg hover:bg-opacity-90 transition-all"
          >
            {ctaData.buttonText}
          </button> 
        </div>
      </section>
    </div>
  );
};
